exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-file-name[data-v-a204cefc]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.details[data-v-a204cefc]{padding:.25rem 0}.slide-fade-enter-active[data-v-a204cefc]{-webkit-transition:all .3s ease;transition:all .3s ease}.slide-fade-leave-active[data-v-a204cefc]{-webkit-transition:all .8s cubic-bezier(1,.5,.8,1);transition:all .8s cubic-bezier(1,.5,.8,1)}.slide-fade-enter[data-v-a204cefc],.slide-fade-leave-to[data-v-a204cefc]{-webkit-transform:translateX(10px);transform:translateX(10px);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a204cefc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/ckFileLink.vue
// module id = h3Md
// module chunks = 0